import { render, staticRenderFns } from "./TransactionList.vue?vue&type=template&id=3872c723"
import script from "../../controllers/transaction/transaction-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/transaction/transaction-list.js?vue&type=script&lang=js&external"
import style0 from "./TransactionList.vue?vue&type=style&index=0&id=3872c723&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports